export default function swDev() {
  let swUrl = `${process.env.PUBLIC_URL}/service-worker.js`
  navigator.serviceWorker.register(swUrl).catch((err) => {
    console.warn("[sw] registration failed:", err?.message || err);
  });
}